module.exports = __webpack_public_path__ + "avai.a531854555f0c044a51d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/avai.woff2
// module id = ./src/assets/webfonts/avai.woff2
// module chunks = styles